export default {
    groupName: 'max',
    appName: 'Max',
    baseRoute: '/dashboard/max',
    label: 'Ad Effect Tracker',
    home: '/slicer',
    image: 'max-new.png',
    description: 'Max Ad Tracker Dashboard'
};


// WEBPACK FOOTER //
// ./src/app/configuration/Max/config/main.js